module.exports = __webpack_public_path__ + "static/media/logo.cb94ab73.webp";